/**
 * Получает значение поля объекта или массива по указанному пути.
 *
 * @param obj {object|array} исходный объект
 * @param path {array|string} путь до элемента в виде массива или строки с разделением точками (dot-notation)
 * @param defaultValue (не обязательно) это значение будет возвращено, если путь не найден
 */
// tslint:disable-next-line:no-any
export const get = (obj: any, path: string | Array<string>, defaultValue: any = undefined): any => {
  if (typeof obj !== 'object' || obj === null) {
    return defaultValue;
  }

  const pathArray = Array.isArray(path) ? path : path.split('.');

  const [item, ...pathRest] = pathArray;

  switch (true) {
    case (typeof obj[item] === 'undefined'):
      return defaultValue;

    case (!!pathRest.length):
      return get(obj[item], pathRest, defaultValue);

    default:
      return obj[item];
  }
};
